import React, { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Button, Column, Text } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import { MEMBERSHIP_POINTS_ITEMS } from './constants'
import ImageContainer from './ImageContainer'
import { Container, Content } from './styles'

type Props = {
  secondary?: boolean
  onAction?: () => void
}

function MembershipPointsSection({ secondary, onAction }: Props) {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()
  const router = useRouter()

  const handleClick = useCallback(
    (link?: string) => {
      if (!link) {
        onAction?.()
        return
      }

      router.push(link)
    },
    [onAction, router],
  )

  const isNotDesktop = !isWideDesktop && !isDesktop

  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container
          gap={[0, 0, 64, 64, 80]}
          pb={[64, 64, 64, 64, 120]}
          pt={[0, 0, 64]}
          secondary={secondary}
        >
          {MEMBERSHIP_POINTS_ITEMS.map((item, index) => (
            <Content
              flexDirection={[
                'column',
                'column',
                'column',
                'column',
                index % 2 !== 0 ? 'row' : 'row-reverse',
              ]}
              gap={[0, 0, 32, 32, 64]}
              key={item.id}
              px={LANDING_CONTENT_PX}
            >
              <ImageContainer item={item} />

              <Column
                alignCenter={isNotDesktop}
                alignStart={!isNotDesktop}
                maxWidth={isNotDesktop ? 420 : 'unset'}
                width={[1, 1, 1, 1, '60%']}
              >
                <SubsectionTitle
                  centered={isNotDesktop}
                  subtitle={item.subtitle}
                  title={item.title}
                />

                <Text
                  body
                  center={isNotDesktop}
                  my={[6, 6, 6, 6, 9]}
                  regular
                  screen14={isNotDesktop}
                  screen18={!isNotDesktop}
                >
                  {item.plainText}
                </Text>

                <Button large onClick={() => handleClick(item.link)}>
                  {item.buttonCaption}
                </Button>
              </Column>
            </Content>
          ))}
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default MembershipPointsSection
